import { getCookie } from '@zoomit/primitives';

import { CPC_REFERRER_COOKIE_KEY } from '../constants/catalog-cpc';
import { getStoreLink } from '../helpers/store-link';
import { useOrigin } from '../providers/OriginProvider';
import { useWebKitCustomization } from './useWebKitCustomization';

export const useStoreLink = () => {
  const { isSameOrigin } = useOrigin();
  const { name } = useWebKitCustomization((x) => x.catalogProvider);

  const getCorrectRefferer = () => {
    if (!isSameOrigin) {
      return process.env.NEXT_PUBLIC_TENANT as string;
    }

    const cpcReferrer = getCookie(CPC_REFERRER_COOKIE_KEY);

    if (cpcReferrer) {
      return cpcReferrer;
    }

    return name;
  };

  const generateLink = ({
    store,
    price,
    position,
  }: {
    store: {
      url: string;
      storeId: string;
      storeLinkId: string;
    };
    price: number;
    position?: string;
  }) => {
    return getStoreLink({
      url: store.url,
      price: price,
      storeId: store.storeId,
      storeLinkId: store.storeLinkId,
      position,
      referrer: getCorrectRefferer(),
    });
  };

  return {
    generateLink,
  };
};
